import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IRootState } from "../store";

export interface ITokenType {
  access_token: string | null;
  refresh_token: string | null;
  session_start?: number | null;
}

const initialState: ITokenType = {
  access_token: null,
  refresh_token: null,
  session_start: null,
};

const tokenSlice = createSlice({
  name: "token",
  initialState,
  reducers: {
    setToken(state: ITokenType, action: PayloadAction<ITokenType>) {
      state.access_token = action.payload.access_token;
      state.session_start = Math.floor(Date.now() / 1000);
      state.refresh_token = action.payload.refresh_token;
    },
    clearToken(state: ITokenType) {
      state.access_token = null;
      state.refresh_token = null;
      state.session_start = null;
    },
  },
});

export const tokenSelector = (state: IRootState) => {
  return state?.token?.access_token;
};
export const refreshTokenSelector = (state: IRootState) => {
  return state?.token?.refresh_token;
};
export const sessionStartSelector = (state: IRootState) => {
  return state?.token?.session_start;
};
export const { reducer } = tokenSlice;

export const { setToken, clearToken } = tokenSlice.actions;

export default tokenSlice;
